import React from 'react';
import { Box, Button, Container, Grid2 as Grid, InputLabel, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import locationImage from '../assets/icons/location.svg';
import axios from 'axios';

const ContactForm: React.FC = () => {

    const { t } = useTranslation();
    const CONTACT_US = t('CONTACT_US') as any;
    const HOME = t('HOME') as any;

    const locations: any = [
        {
            name: CONTACT_US.FORM.LOCATIONS.ZURICH.NAME,
            company: CONTACT_US.FORM.LOCATIONS.ZURICH.COMPANY,
            address: CONTACT_US.FORM.LOCATIONS.ZURICH.ADDRESS,
            city: CONTACT_US.FORM.LOCATIONS.ZURICH.CITY,
            postcode: CONTACT_US.FORM.LOCATIONS.ZURICH.POSTCODE
        },
        {
            name: CONTACT_US.FORM.LOCATIONS.OSIJEK.NAME,
            company: CONTACT_US.FORM.LOCATIONS.OSIJEK.COMPANY,
            address: CONTACT_US.FORM.LOCATIONS.OSIJEK.ADDRESS,
            city: CONTACT_US.FORM.LOCATIONS.OSIJEK.CITY,
            postcode: CONTACT_US.FORM.LOCATIONS.OSIJEK.POSTCODE
        }
    ];
    interface ContactRequest {
        name: "",
        email: "",
        message: ""
    }

    const [contactRequest, setContactRequest] = React.useState<ContactRequest>({
        name: "",
        email: "",
        message: ""
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = event.target.value;
        if (name === "message" && value.length > 300) {
            return;
        }
        setContactRequest(contactRequest => ({ ...contactRequest, [name]: value }));
    }

    const sendEmail = () => {

        if (contactRequest.name.length === 0) {
            return;
        }

        const urlPattern = new RegExp("^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$");
        if (!urlPattern.test(contactRequest.email)) {
            return;
        }

        if (contactRequest.message.length === 0) {
            return;
        }

        /* const SERVICE_ID = "service_32b74u6";
        const TEMPLATE_ID = "template_o2s637s";
        const PUBLIC_KEY = "BREocLy0PiODlvxvU"; */

        const TEMPLATE_PARAMS = {
            from_name: contactRequest.name,
            email: contactRequest.email,
            message: contactRequest.message
        };

        axios.post('/send-form', TEMPLATE_PARAMS)
            .then(() => {
                alert(HOME.EMAIL_SENT_SUCCESSFULLY);
            })
            .catch(error => {
                console.log(error.text);
            })

        setContactRequest(contactRequest => ({ ...contactRequest, name: "", email: "", message: "" }));

    }
    return (
        <Box
            sx={{
                width: '100vw',
                position: 'relative',
                left: '50%',
                right: '50%',
                marginLeft: '-50vw',
                marginRight: '-50vw',
                background: `linear-gradient(180deg, #FFF 0%, var(--Be-B-100, #F7F4F2) 100%)`,
            }}
        >
            <Container
                sx={{
                    maxWidth: "1440px !important",
                    padding: {
                        xs: "98px 16px 24px 16px !important",
                        sm: "128px 12px 20px 12px !important",
                        md: "100px 120px !important"
                    },
                    background: `linear-gradient(180deg, #FFF 0%, var(--Be-B-100, #F7F4F2) 100%)`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                }}>
                <Grid container direction="row" spacing={{ xs: 4, md: 5 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography color="primary.light" textAlign={{ xs: 'center', md: 'left' }} sx={{ fontSize: '14px', whiteSpace: 'pre-line', fontWeight: 700, lineHeight: '21px' }}>
                            {CONTACT_US.FORM.TITLE}
                        </Typography>
                        <Typography color="secondary.main" textAlign={{ xs: 'center', md: 'left' }} sx={{ fontSize: '32px', whiteSpace: 'pre-line', fontWeight: 700, lineHeight: '48px' }} pt={1}>
                            {CONTACT_US.FORM.SUBTITLE}
                        </Typography>
                        <Typography color="secondary.main" textAlign={{ xs: 'center', md: 'left' }} sx={{ fontSize: '16px', whiteSpace: 'pre-line', fontWeight: 400, lineHeight: '24px' }} pt={2}>
                            {CONTACT_US.FORM.DESCRIPTION}
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }} mt={{ xs: 3, md: 5 }}>
                            {locations.map((location: any, index: number) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: 'flex',
                                        alignItems: { xs: 'center', md: 'flex-start' },
                                        gap: 1,
                                        justifyContent: { xs: 'center', md: 'flex-start' }
                                    }}
                                >
                                    <img
                                        loading="lazy"
                                        src={locationImage}
                                        srcSet={locationImage}
                                        alt="location"
                                        title="location" />
                                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 700,
                                                color: 'secondary.main',
                                                fontSize: '16px',
                                                lineHeight: '24px'
                                            }}
                                        >
                                            {location.name}
                                        </Typography>
                                        <Typography>
                                            {location.company}<br />
                                            {location.address}<br />
                                            {location.postcode} {location.city}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} textAlign="left" sx={{
                        borderRadius: '16px',
                        background: '#FFF',
                        boxShadow: '0 0 19px 0 rgba(210, 196, 204, 0.50)',
                        padding: { xs: '24px', md: '32px' }
                    }}>
                        <Grid container direction="row" spacing={{ xs: 3, md: 4 }}>
                            <Typography color="primary.dark" sx={{ fontSize: '20px', whiteSpace: 'pre-line', fontWeight: 700, lineHeight: 'normal' }}>
                                {CONTACT_US.FORM.FORM_TITLE}
                            </Typography>
                            <Grid size={{ xs: 12, sm: 6, md: 12, lg: 12, xl: 12 }}>
                                <div>
                                    <Grid container>
                                        <Grid size={12}>
                                            <InputLabel>{CONTACT_US.FORM.NAME_LABEL}</InputLabel>
                                            <TextField
                                                id="name"
                                                name="name"
                                                fullWidth
                                                placeholder={CONTACT_US.FORM.NAME_LABEL}
                                                value={contactRequest.name || ''}
                                                onChange={handleChange}
                                            />

                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{ mt: 3 }}>
                                        <Grid size={12}>
                                            <InputLabel>{CONTACT_US.FORM.EMAIL_LABEL}</InputLabel>
                                            <TextField
                                                id="email"
                                                name="email"
                                                fullWidth
                                                placeholder={CONTACT_US.FORM.EMAIL_LABEL}
                                                type="email"
                                                value={contactRequest.email || ''}
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{ mt: 3 }}>
                                        <Grid size={12}>
                                            <InputLabel>{CONTACT_US.FORM.MESSAGE_LABEL}</InputLabel>
                                            <TextField
                                                id="message"
                                                name="message"
                                                fullWidth
                                                placeholder={CONTACT_US.FORM.MESSAGE_TEXT}
                                                multiline
                                                rows={5}
                                                value={contactRequest.message || ''}
                                                onChange={handleChange}
                                            />
                                            <Grid size={12} sx={{ display: "flex", maxWidth: 470 }}>
                                                <Typography sx={{ color: "#B4ADA9", fontWeight: 400, fontSize: "14px", lineHeight: "16px", marginLeft: "auto" }}>
                                                    {contactRequest.message.length}/300
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid size={12}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                fullWidth
                                                onClick={() => sendEmail()}
                                                sx={{
                                                    mt: 3,
                                                    padding: '16px 32px',
                                                    borderRadius: '24px',
                                                    height: 48,
                                                    bgcolor: '#4E2A3C'
                                                }}
                                            >
                                                <Typography color='text.secondary' sx={{ fontWeight: 700, fontSize: "16px" }}>
                                                    {CONTACT_US.FORM.SUBMIT_BUTTON}
                                                </Typography>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default ContactForm;